import clsx from 'clsx'
import React from 'react'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'

import {
   Button,
   DashboardLayout,
   Input,
   Select,
   Switch,
} from '../../components'
import { isDesktop } from '../../utils'
import { updateSetting } from '../../store/user'

import './Settings.scss'

const OPTIONS = [
   { value: 'A', title: 'Binance Smart Chain' },
]

const Settings = () => {
   const dispatch = useDispatch()
   const { isDarkTheme } = useSelector(state => state.theme)
   const { settings, privateKey, privateKeyEncrypted } = useSelector(
      state => state.user
   )

   const [network, setNetwork] = React.useState(null)
   const [password, setPassword] = React.useState('')
   const [showFlag, setShowFlag] = React.useState('')

   const downloadKey = () => {
      const element = document.createElement('a')
      const file = new Blob([privateKeyEncrypted], {
         type: 'text/plain',
      })
      element.href = URL.createObjectURL(file)
      element.download = 'key.txt'
      document.body.appendChild(element)
      element.click()
   }

   const showKeys = async() =>{
      let response = await axios.post(
         `${process.env.REACT_APP_API_URL}/api/auth/decryptPrivateKey`,
         {
            downloadKey: privateKeyEncrypted,
            password: password,
         }
      )
      
      if(response.data.privateKey===privateKey){
         setShowFlag(true)
      }
   }

   if (isDesktop()) {
      return (
         <DashboardLayout>
            <div
               className={clsx(
                  'DesktopSettings',
                  isDarkTheme && 'DesktopSettings--dark'
               )}
            >
               <div className="DesktopSettings__card">
                  <h2 className="DesktopSettings__heading">Private Keys</h2>
                  <p className="DesktopSettings__paragraph">
                     Here you can export your Private Key from WSNS to with
                     another wallet. Never share your key or password.
                  </p>
                  <Select
                     className="DesktopSettings__select"
                     current={network}
                     options={OPTIONS}
                     placeholder="Select Network"
                     onChange={selectedOption => setNetwork(selectedOption)}
                     isDarkTheme={isDarkTheme}
                  />
                  <div className="DesktopSettings__input-group">
                     <Input
                        className="DesktopSettings__input-group-password"
                        type="password"
                        placeholder="Password"
                        onChange={e => setPassword(e.target.value)}
                        isDarkTheme={isDarkTheme}
                     />
                     <Button
                        className="DesktopSettings__input-group-btn"
                        variant="solid"
                        color="primary"
                        isDarkTheme={isDarkTheme}
                        onClick={()=>showKeys()}
                     >
                        Show
                     </Button>
                  </div>
                  <h2 className="DesktopSettings__heading">Key File</h2>
                  <p className="DesktopSettings__paragraph">
                     WSNS Account key file includes all assets from your
                     multi-chain wallet. You can either copy the string of
                     symbols manually or click the Download button to get it.
                  </p>
                  <textarea
                     className="DesktopSettings__textarea"
                     rows="10"
                     value={password!==''&&showFlag?
                        ('Private Key: ' +
                        privateKey +
                        '\nPrivate Key Encrypted: ' +
                        privateKeyEncrypted)
                        :
                        ('')
                     }
                  />
                  <Button
                     className="DesktopSettings__download"
                     variant="solid"
                     color="primary"
                     onClick={() => downloadKey()}
                     isDarkTheme={isDarkTheme}
                     size="lg"
                  >
                     Download
                  </Button>
                  <Button
                     className="DesktopSettings__copy"
                     variant="ghost"
                     color="primary"
                     onClick={() =>
                        navigator.clipboard.writeText(privateKeyEncrypted)
                     }
                     isDarkTheme={isDarkTheme}
                     size="lg"
                  >
                     Copy
                  </Button>
                  <div className="DesktopSettings__switch">
                     <p className="DesktopSettings__switch-label">
                        Ask password on transaction
                     </p>
                     <Switch
                        name="pswd-on-txn"
                        checked={settings.askPasswordOnTxn}
                        onChange={() =>
                           dispatch(
                              updateSetting({ setting: 'askPasswordOnTxn' })
                           )
                        }
                     />
                  </div>
                  <div className="DesktopSettings__switch">
                     <p className="DesktopSettings__switch-label">
                        Set session timeout to 15 mins
                     </p>
                     <Switch
                        name="session-timeout"
                        checked={settings.autoSessionTimeout}
                        onChange={() =>
                           dispatch(
                              updateSetting({ setting: 'autoSessionTimeout' })
                           )
                        }
                     />
                  </div>
               </div>
            </div>
         </DashboardLayout>
      )
   }

   return (
      <DashboardLayout
         className={clsx('Settings', isDarkTheme && 'Settings--dark')}
      >
         <h2 className="Settings__heading">Private Keys</h2>
         <p className="Settings__paragraph">
            Here you can export your Private Key from WSNS to with another
            wallet. Never share your key or password.
         </p>
         <Select
            className="Settings__select"
            current={network}
            options={OPTIONS}
            placeholder="Select Network"
            isDarkTheme={isDarkTheme}
            onChange={selectedOption => setNetwork(selectedOption)}
         />
         <div className="Settings__input-group">
            <Input
               className="Settings__input-group-password"
               type="password"
               placeholder="Password"
               onChange={e => setPassword(e.target.value)}
               isDarkTheme={isDarkTheme}
            />
            <Button
               className="Settings__input-group-btn"
               variant="solid"
               color="primary"
               isDarkTheme={isDarkTheme}
               onClick={()=>showKeys()}
            >
               Show
            </Button>
         </div>
         <h2 className="Settings__heading">Key File</h2>
         <p className="Settings__paragraph">
            WSNS Account key file includes all assets from your multi-chain
            wallet. You can either copy the string of symbols manually or click
            the Download button to get it.
         </p>
         <textarea
            className="Settings__textarea"
            rows="10"
            value={password!==''&&showFlag?
               ('Private Key: ' +
               privateKey +
               '\nPrivate Key Encrypted: ' +
               privateKeyEncrypted)
               :
               ('')
            }
         />
         <Button
            className="Settings__download"
            variant="solid"
            color="primary"
            onClick={() => downloadKey()}
            isDarkTheme={isDarkTheme}
         >
            Download
         </Button>
         <Button
            className="Settings__copy"
            variant="ghost"
            color="primary"
            onClick={() => navigator.clipboard.writeText(privateKeyEncrypted)}
            isDarkTheme={isDarkTheme}
         >
            Copy
         </Button>
      </DashboardLayout>
   )
}

export default Settings
